/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.dropdown-toggle' ).on( 'toggleAfter', ( event ) => {
        if ( window.easyToggleState.isActive( event.target ) ) {
          $( $( event.target ).attr( 'data-dropdown-id' ) ).slideToggle();
        } else {
          $( $( event.target ).attr( 'data-dropdown-id' ) ).slideToggle();
        }
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      // when a filter is changed, filter the careers and categories by both filters
      $( '.filters select' ).on( 'change', function() {
        // hide/show the category groups based on category chosen
        if ( $( '.filters select[name="category"]' ).val() !== '' ) {
          // hide any category that is not the chosen category
          $( '.category-group:not([data-category="' + $( '.filters select[name="category"]' ).val() + '"])' ).hide();
          // show any category that is not the chosen category
          $( '.category-group[data-category="' + $( '.filters select[name="category"]' ).val() + '"]' ).show();
        } else {
          // if the placeholder is chosen, show all categories
          $( '.category-group' ).show();
        }

        // go through every category, and if there's no visible videos inside, hide the category group. otherwise, show the group.
        $( '.category-group' ).each( function( key, group ) {
          if ( $( group ).find( '.video:visible' ).length == 0 ) {
            $( group ).hide();
          } else {
            $( group ).show();
          }
        } );
      } );

      $( '.faq-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      $( '.faq-toggle-two' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      if ( $( '.gform_wrapper' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
          if ( $( '#input_' + formId + '_' + fieldId ).val() ) {
            const path = $( '#input_' + formId + '_' + fieldId ).val().replace( 'C:\\fakepath\\', '' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( path );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).addClass( 'has-file' );
          } else {
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( 'No file selected' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).removeClass( 'has-file' );
          }
        }, 10, 3 );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
